import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function importWalletCsv(
  accountId: string,
  walletId: string,
  files: File[],
) {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));

  try {
    await axios.post(
      `/accounts/${accountId}/wallets/${walletId}/csv`,
      formData,
    );
  } catch (error) {
    throwSylaApiError(error);
  }
}
